



























































































import Vue from "vue"

import {DpdProduct} from "@/model/new-parcel-model/dpd-product/dpd-product"
import {Company} from "@/model/entity/company/company"
import _ from "lodash"
import {plainToClass} from "class-transformer"
import { convertServiceCodeToTextCode, convertTextCodeToServiceCode } from "@/util/service-text-codes-converter"
import { DpdProductFull } from "@/model/new-parcel-model/dpd-product/dpd-product-full"

interface ProductDto {
    serviceCode: number
    serviceTextCode: string
    description: string
    active: boolean
}

interface Data {
    searchProduct: string
    companyProducts: ProductDto[]
    products: DpdProductFull[]
    allProductsChecked: boolean
    isIndeterminate: boolean
    defaultProps: any
    $refs: any
    checkedProductsList: string[]
    defaultExpandedKeys: string[]
    checkedServiceTextCodes: string[]
    defaultTextCodeProduct: string
}

const KEY_SEPARATOR = "__"

export default Vue.extend({
    data(): Data {
      return {
        searchProduct: "",
        companyProducts: [],
        products: [],
        allProductsChecked: false,
        isIndeterminate: false,
        defaultProps: {
          children: "children",
          label: "label"
        },
        defaultExpandedKeys: [],
        $refs: {
          tree: {} as any
        },
        checkedProductsList: [],
        checkedServiceTextCodes: [],
        defaultTextCodeProduct: ""
      }
    },
    props: {
      company: {
        type: Object as () => Company,
        required: true
      }
    },
    methods: {
       filterNode(value, data, node) {
          if (!value) {
            this.collapseNodes()
            return true
          }

          const searchResults = []
          // FILTER NODE AND CALL ALL NODES RECURSIVLY
          this.getReturnNode(node, searchResults, value)
          let result = false
          searchResults.forEach(item => {
            result = result || item
          })

          return result

      },

      getReturnNode(node, searchResults, value) {

        const foundNode =
        node.data
        && node.data.variantLabel
        && _.toUpper(node.data.variantLabel).indexOf(_.toUpper(value)) !== -1
        // foundNode ? searchResults.push(foundNode) : ""
        if (foundNode) {
            searchResults.push(foundNode)
        }
        // CALL RETURN NODE FOR EACH CHILD NODE
        if (!foundNode && node.level !== 1 && node.parent) {
            this.getReturnNode(node.parent, searchResults, value)
        }
      },
      collapseNodes() {
        this.defaultExpandedKeys = []
        // FIND EACH CHILD NODES PARENT AND COLLAPSE THEM
        Object.keys(this.$refs.productsTree.store.nodesMap).forEach(key => {
            if (!this.defaultExpandedKeys.includes(key)) {
              this.$refs.productsTree.store.nodesMap[key].parent.parent.expanded = false
            }
        })
      },
      expandChildNodes(data) {
          this.defaultExpandedKeys = []
          if (data.children[0].children) {
            data.children[0].children.forEach((node) => {
                this.defaultExpandedKeys.push(node.key)
            })
          }
      },
      async getAllProductsData() {
        const vm = this
        let temporaryResponse = null
        await this.$http
          .get("/product/all_products")
          .then(response => {
            temporaryResponse = response.data.map((product) => {
              return {name: product.title, type: product.type, dpdProductVariants: [{}]}
            })
          })

        // tslint:disable-next-line:prefer-for-of
        for (let index = 0; index < temporaryResponse.length; index++) {
          const element = temporaryResponse[index]
          const res = await this.$http.get(`/product/product_variants/${element.type}`)
          element.dpdProductVariants = res.data
        }
        vm.products = temporaryResponse
      },
      getDisabledDefaultOption(key: string) {
          const isActive = !this.checkedProductsList.includes(key)
          return isActive
      },
      findVariant(serviceCode: string, serviceTextCode: string) {
        for (const product of this.products) {
          const variant = product.dpdProductVariants.find(v =>
            String(v.serviceCode) === String(serviceCode) && v.serviceTextCode === serviceTextCode
          )
          if (variant) {
            return variant
          }
        }
        return null
      },
      findVariantById(id: string) {
        for (const product of this.products) {
          const variant = product.dpdProductVariants.find(v => String(v.id) === String(id))
          if (variant) {
            return variant
          }
        }
        return null
      },
      setActiveProduct() {
        // TRIGGERS WHEN CHECKBOX IS CHECKED- SETS ACTIVE COMPANY AND DEFAULT PRODUCT AS SERVICE CODES
        this.checkedProductsList = []
        if (this.$refs.productsTree.getCheckedKeys()) {
          this.checkedProductsList = this.$refs.productsTree.getCheckedKeys().filter(el => el && el)
        }

        this.company.productVariants = this.checkedProductsList.map(el => el && el.split(KEY_SEPARATOR)[0]).join(",")
        if (!notEmpty(this.company.defaultProduct) && this.checkedProductsList.length === 1) {
          this.defaultTextCodeProduct = this.checkedProductsList[0]
          const [serviceCode, serviceTextCode] = this.defaultTextCodeProduct.split(KEY_SEPARATOR)
          const variant = this.findVariant(serviceCode, serviceTextCode)
          if (variant) {
            this.company.defaultProduct = variant.id.toString()
          }
        }

      },
      setDefaultCompanyProduct() {
        if (!this.defaultTextCodeProduct) {
          return
        }
        const [serviceCode, serviceTextCode] = this.defaultTextCodeProduct.split(KEY_SEPARATOR)
        const variant = this.findVariant(serviceCode, serviceTextCode)
        if (variant) {
          this.company.defaultProduct = variant.id.toString()
        }
      },
      handleCheckAllChange(value: boolean) {
        this.checkedProductsList = []
        // IF ALL PRODUCTS ARE UNCHECKED THEN VALUE IS FALSE
        if (!value) {
          this.company.defaultProduct = ""
          this.defaultTextCodeProduct = ""
          this.$refs.productsTree.setCheckedKeys(this.checkedProductsList)

        } else if (value) {
            this.products.map((product) => {
              product.dpdProductVariants.map((variant) => {
                if (variant.serviceTextCode && variant.serviceCode) {
                    this.checkedProductsList.push(`${variant.serviceCode}${KEY_SEPARATOR}${variant.serviceTextCode}`)
                }
              })
            })
            this.$refs.productsTree.setCheckedKeys(this.checkedProductsList)

            if (!notEmpty(this.company.defaultProduct)) {
                const firstVariant = this.products[0].dpdProductVariants[0]
                this.company.defaultProduct = firstVariant.id.toString()
                this.defaultTextCodeProduct =
                `${firstVariant.serviceCode}${KEY_SEPARATOR}${firstVariant.serviceTextCode}`

            }
        }
        this.setActiveProduct()

      },
      setInitialCheckedProducts() {
        if (this.$refs.productsTree) {
            this.checkedProductsList = []
            if (!this.company.id) {
              // TRIGGERS WHEN MODAL CLOSES
              this.collapseNodes()
              this.searchProduct = ""
              this.company.defaultProduct = ""
              this.defaultTextCodeProduct = ""
              this.$refs.productsTree.setCheckedKeys(this.checkedProductsList)
            } else {
              let companyProductVariants =
              !this.company.productVariants ? [] : this.company.productVariants.split(",")
              companyProductVariants = _.uniq(companyProductVariants).filter(el => el && el)
              const companyCombinedKey = []
              companyProductVariants.forEach((serviceCode) => {
                // CONVERTS INITIAL COMPANY CODES TO TEXT CODES FOR TREE REQUIREMANTS
                const serviceTextCodes = convertServiceCodeToTextCode(this.products, serviceCode)
                serviceTextCodes.forEach((serviceText) => {
                  companyCombinedKey.push(`${serviceCode}${KEY_SEPARATOR}${serviceText}`)
                })
              })
              this.checkedProductsList = companyCombinedKey
              const defaultVariant = this.findVariantById(this.company.defaultProduct)
              this.defaultTextCodeProduct = defaultVariant
                ? `${defaultVariant.serviceCode}${KEY_SEPARATOR}${defaultVariant.serviceTextCode}`
                : ""
              // SET INITIAL CHECKED KEYS IN TREE USING SERVICE TEXT CODES
              this.$refs.productsTree.setCheckedKeys(this.checkedProductsList)
            }

        }

      }

    },
    computed: {
      treeData(): any {
        return this.products.map(product => {
          return {
            label: product.name,
            isHeader: true,
            children: [{
              isHeader: true,
              default: `${this.$t("user_administration.default")}`,
              headerServiceCode: `${this.$t("user_administration.service_code")}`,
              headerServiceTextCode: `${this.$t("user_administration.service_text_code")}`,
              headerDescription: `${this.$t("user_administration.description")}`,
              children: product.dpdProductVariants.map(variant => {
                return {
                  variantLabel: variant.description,
                  serviceCode: variant.serviceCode,
                  serviceTextCode: variant.serviceTextCode,
                  isHeader: false,
                  key: `${variant.serviceCode}${KEY_SEPARATOR}${variant.serviceTextCode}`,

                  newData: variant
                }
              })

            }]

          }
        })
      }
    },
    watch: {
      products: {
        handler() {
          this.setInitialCheckedProducts()
        }
      },
      company: {
        immediate: true,
        handler() {
          this.setInitialCheckedProducts()
        }
      },
      searchProduct(product) {
        this.$refs.productsTree.filter(product)
      }
    },
    async created() {
      await this.getAllProductsData()
    }
})
